<template>
	<div class="cart-item p-3 flex-center">
		<div>
			<!-- <div>{{ productId }}</div> -->
			<div><b>{{ index + 1 }}.</b> {{ item.product_name }}</div>
			<!-- Variation -->
			<div class="mt-2" v-if="product && !!item.variation">
				<multiselect
					class="form-control"
					v-model="selectedVariation"
					placeholder="Select Variation"
					label="name"
					track-by="name"
					:custom-label="variationLabel"
					:options="product.variations.prices"
					:preselect-first="false"
					:allow-empty="false"
					:show-labels="false"
					@select="onVariationSelected">
				</multiselect>
			</div>
		</div>
		<div class="ml-auto">
			<div class="d-flex align-items-center">
				<!-- Quantity -->
				<div class="input-group input-group-sm input-group-quantity">
					<div class="input-group-prepend">
						<button
							type="button"
							class="btn btn-default flex-center"
							:class="{ 'disabled': item.qty === 1 }"
							:disabled="item.qty === 1"
							@click="reduceQty">
							<i class="material-icons">remove</i>
						</button>
					</div>
					<input
						type="number"
						min="0"
						class="input input-number text-right form-control"
						v-model="item.qty"
						@change="onQtyChange">
					<div class="input-group-append">
						<button
							type="button"
							class="btn btn-default flex-center"
							:class="{ 'disabled': isAddQtyDisabled }"
							:disabled="isAddQtyDisabled"
							@click="addQty">
							<i class="material-icons">add</i>
						</button>
					</div>
				</div>
				<!-- Remove -->
				<button
					type="button"
					class="btn btn-sm btn-plain ml-2"
					v-tooltip="'Remove Cart Item'"
					@click="remove">
					<i class="material-icons text-danger">close</i>
				</button>
			</div>
			<div class="mt-2" v-if="isStockEnabled">Stock: {{ stockQty }}</div>
		</div>
	</div>
</template>

<script>
import { getWholesalePrice, duplicateVar, formatNumberPlain } from '../lib/helper';

export default {
	name: 'CartItem',
	props: {
		products: {
			type: Array,
			default: () => [],
		},
		item: {
			type: Object,
		},
		index: {
			type: Number,
			default: 1,
		},
	},
	data() {
		return {
			selectedVariation: null,
		};
	},
	methods: {
		addQty() {
			const qty = this.item.qty + 1;
			this.$set(this.item, 'qty', qty);
			this.onQtyChange();
		},
		reduceQty() {
			const qty = this.item.qty - 1;
			this.$set(this.item, 'qty', qty);
			this.onQtyChange();
		},
		onQtyChange() {
			// const productPrice = this.isVariableProduct
			// 	? this.selectedVariation.price : duplicateVar(this.product.price);
			// let wholesales = [];
			// if (this.isVariableProduct) {
			// 	wholesales = this.selectedVariation && this.selectedVariation.wholesale
			// 		? this.selectedVariation.wholesale : [];
			// } else {
			// 	wholesales = this.item.wholesale || [];
			// }
			// const cartQty = this.item.qty;
			// const productFinalPrice = getWholesalePrice(wholesales, cartQty, productPrice);
			// const cartPrice = cartQty * productFinalPrice;
			// this.$set(this.item, 'price', cartPrice);
			const stock = this.stock ? duplicateVar(this.stock.quantity) : 100000;
			let currentQty = parseInt(this.item.qty);
			if (!currentQty || Number.isNaN(currentQty) || currentQty === 0 || currentQty === '') {
				currentQty = 1;
			} else if (this.isStockEnabled && currentQty > stock) {
				currentQty = stock;
			}
			currentQty = parseInt(currentQty);
			this.item.qty = currentQty;

			this.updatePrice();
			this.$emit('change', this.item);
		},
		setVariation() {
			if (this.product && this.product.variations && this.product.variations.prices) {
				const prices = this.product.variations.prices;
				const selectedVariation = prices.find(({ name }) => name === this.item.variation);
				if (selectedVariation) {
					this.selectedVariation = selectedVariation;
				}
			}
		},
		variationLabel({ name }) {
			return name ? name.split('||').join(' - ') : '';
		},
		remove() {
			this.$emit('remove');
		},
		updatePrice() {
			const productPrice = this.isVariableProduct
				? this.selectedVariation.price : duplicateVar(this.product.price);
			let wholesales = [];
			if (this.isVariableProduct) {
				wholesales = this.selectedVariation && this.selectedVariation.wholesale
					? this.selectedVariation.wholesale : [];
			} else {
				wholesales = this.product.wholesale || [];
			}
			const cartQty = this.item.qty;
			const productFinalPrice = getWholesalePrice(wholesales, cartQty, productPrice);
			const cartPrice = cartQty * productFinalPrice;
			this.$set(this.item, 'price', cartPrice);
		},
		onVariationSelected(variation) {
			this.$set(this.item, 'variation', variation.name);
			this.$set(this.item, 'weight', variation.weight);
			this.updatePrice();
			this.$emit('change', this.item);
		},
	},
	computed: {
		productId() {
			return this.item.product_id.$oid;
		},
		product() {
			const product = this.products.find(product => product.product_id.$oid === this.productId);
			return product;
		},
		isVariableProduct() {
			return this.item.variation && this.item.variation !== '';
		},
		stock() {
			const stock = this.isVariableProduct && this.selectedVariation ? this.selectedVariation.stock : this.product.stock;
			return stock;
		},
		isStockEnabled() {
			return this.stock && this.stock.enabled;
		},
		isAddQtyDisabled() {
			const isDisabled = this.stock && this.stock.enabled && this.stock.quantity === this.item.qty;
			return isDisabled;
		},
		stockQty() {
			const stock = this.stock ? formatNumberPlain(this.stock.quantity) : '';
			return stock;
		},
	},
	created() {
		this.setVariation();
	},
};
</script>

<style lang="scss">
.cart-item {
	border-bottom: 1px solid #ddd;

	&:last-child {
		border-bottom: 0;
	}
}
</style>
